import { render, staticRenderFns } from "./products.vue?vue&type=template&id=1726234f&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=1726234f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726234f",
  null
  
)

export default component.exports